import { MARK_INBOX_READ } from "../constants/inbox.api";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

export const useMarkInboxRead = () => {
  return useCustomMutation({
    url: MARK_INBOX_READ,
    // Overriding the generic onError with empty function as we don't want to show even error if this API fails
    onError: () => {},
  });
};
